<div style="display: flex;">
  <button class="chat-toggle-mobile" #chatToggle (click)="toggleChat()">
    <img src="/scripts/chatbot/resources/ai-logo.svg" id="chat-toggle-mobile" />
  </button>
  <button class="chat-toggle-desktop" #chatToggle (click)="toggleChat()">
    <img src="/scripts/chatbot/resources/ai-logo.svg" id="chat-toggle-desktop" />
  </button>
  <div #chatPopup
       class="floating-chat-popup"
       [class.visible]="chatVisible"
       [style.display]="chatVisible ? 'flex' : 'none'">
    <div class="chat-popup-header" (mousedown)="startDrag($event)" (touchstart)="startDrag($event)">
    </div>
    <iframe #chatIframe id="chat-iframe" src="/scripts/chatbot/customChat.html" frameborder="0" loading="lazy"></iframe>
    <div #resizeHandle class="custom-resize-handle"
         (mousedown)="startResize($event)"
         (touchstart)="startResize($event)">
    </div>
  </div>
</div>